export const CLOUDINARY = 'cloudinary.com'
export const BLAZE_ECOMMERCE = 'BLAZE ECOM'
export const BLAZE_COMPANY = 'BLAZE'
export const GREENLINE_LOYALTY = 'Greenline Loyalty'
